<template>
  <div>
    <div class="admin admin--list-lot u-indent-m-b-45px">
      <div class="a-tab__title-block admin__a-tab u-margin-top-0 admin__a-tab--modification-controls">
        <h3>{{$t('form.reports.settings')}}</h3>
      </div>
      <div class="admin__a-tab-content admin__a-tab-content--show">
        <div class="a-filter">
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.report-type')}}</div>
            <dropdown-new class="select-w-380" v-model="filters.reportType">
              <option :value="enums.ReportType.PROCEDURES_BY_STAGE" :label="'report-type.procedures-by-stage'"></option>
              <option :value="enums.ReportType.ECONOMY" :label="'report-type.economy'"></option>
              <option :value="enums.ReportType.ACCEPTANCE_PRICE" :label="'report-type.acceptance-price'"></option>
              <option :value="enums.ReportType.SUMMARY_REGISTRY" :label="'report-type.summary-registry'"></option>
              <option :value="enums.ReportType.TMC" :label="'report-type.tmc'"></option>
            </dropdown-new>
          </div>
          <div class="a-filter__body ">
            <div class="a-filter__block admin-filter__block">
              <div class="a-filter__label admin-filter__label">{{$t('form.reports.tender-creation-date.label')}}:</div>
              <div class="a-input-group ">
                <p>{{$t('form.reports.tender-creation-date.from.label')}}:</p>
                <div class="a-input-group__prepend ">
                  <img src="@/assets/img/static/vector.svg" alt="">
                </div>
                <date-picker v-model="filters.creationDate.from"></date-picker>
              </div>
              <div class="a-input-group ">
                <p>{{$t('form.reports.tender-creation-date.to.label')}}:</p>
                <div class="a-input-group__prepend ">
                  <img src="@/assets/img/static/vector.svg" alt="">
                </div>
                <date-picker v-model="filters.creationDate.to"></date-picker>
              </div>
            </div>
            <div class="a-filter__block admin-filter__block">
              <div class="a-filter__label admin-filter__label">{{$t('form.reports.tender-publish-date.label')}}:</div>
              <div class="a-input-group ">
                <p>{{$t('form.reports.tender-publish-date.from.label')}}:</p>
                <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
                <date-picker v-model="filters.publicationDate.from"></date-picker>
              </div>
              <div class="a-input-group ">
                <p>{{$t('form.reports.tender-publish-date.to.label')}}:</p>
                <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
                <date-picker v-model="filters.publicationDate.to"></date-picker>
              </div>
            </div>
            <div class="a-filter__block admin-filter__block">
              <div class="a-filter__label admin-filter__label">{{$t('form.reports.lot-price.label')}}:</div>
              <div class="a-input-group ">
                <p>{{$t('form.reports.lot-price.from.label')}}:</p>
                <input-cost v-model="filters.price.from"></input-cost>
              </div>
              <div class="a-input-group ">
                <p>{{$t('form.reports.lot-price.to.label')}}:</p>
                <input-cost v-model="filters.price.to"></input-cost>
              </div>
              <dropdown-new class="select-w-140"
                            :options="enums.Currency.options.all"
                            v-model="filters.price.currency">
                </dropdown-new>
            </div>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.lot-count.label')}}:</div>
            <input-number class="select-w-77" :maxDigits="5" v-model="filters.countLot"></input-number>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.department.label')}}:</div>
            <department-search class="select-w-570"
                               multiple
                               v-model="filters.initiator.departments">
            </department-search>
          </div>

          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.owner.label')}}:</div>
            <user-search class="select-w-570"
                         multiple
                         organizer
                         main-organizer
                         v-model="filters.organizer.persons">
            </user-search>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.owner-department.label')}}:</div>
            <department-search class="select-w-570"
                               multiple
                               v-model="filters.organizer.departments">
            </department-search>
          </div>
          <div class="a-container-form">
            <div class="a-label a-label--w-215">{{$t('form.reports.tender-method.label')}}:</div>
            <dropdown-new class="select-w-380"
                          :placeholder="$t('tender-method.empty')"
                          v-model="filters.tender.method">
              <option value :label="'tender-method.empty'"></option>
              <option :value="enums.TenderMethod.TENDER" :label="'tender-method.tender'"></option>
              <option :value="enums.TenderMethod.REQUEST_FOR_PRICE" :label="'tender-method.request-for-price'"></option>
              <option :value="enums.TenderMethod.REQUEST_FOR_PROPOSALS" :label="'tender-method.request-for-proposals'"></option>
              <option :value="enums.TenderMethod.ONE" :label="'tender-method.one'"></option>
              <option :value="enums.TenderMethod.REDUCTION" :label="'tender-method.reduction'"></option>
            </dropdown-new>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.participation-mode.label')}}:</div>
            <dropdown-new class="select-w-380" v-model="filters.tender.participationMode">
              <option value :label="'tender-participation-mode.empty'"></option>
              <option :value="enums.TenderParticipationMode.OPEN" :label="'tender-participation-mode.open'"></option>
              <option :value="enums.TenderParticipationMode.CLOSED" :label="'tender-participation-mode.closed'"></option>
            </dropdown-new>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.categories.label')}}:</div>
            <categories-search class="select-w-570"
                               multiple
                               full-search
                               tags
                               :placeholder="$t('form.reports.categories.placeholder')"
                               v-model="filters.categories">
            </categories-search>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.lot-number.label')}}:</div>
            <lot-number-search class="select-w-380" v-model="filters.lotNumber"></lot-number-search>
          </div>
          <div class="a-container-form ">
            <div class="a-label a-label--w-215">{{$t('form.reports.tender-number.label')}}:</div>
            <input type="text" class="a-input" v-model="filters.tenderNumber"/>
          </div>
          <div class="a-filter__footer ">
            <button class="gui-btn gui-btn--white-border gui-btn--w-167" @click.prevent="onResetClick">{{$t('buttons.reset-filters')}}</button>
            <button class="gui-btn gui-btn--red gui-btn--w-260" @click.prevent="onShowReportClick">{{$t('buttons.create-report')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TenderMethod from '@/api/types/tender-method'
  import Currency from '@/api/types/currency'
  import ReportType from '@/api/types/report-type'
  import TenderParticipationMode from '@/api/types/tender-participation-mode'

  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'
  import DepartmentSearch from '@/components/common/inputs/DepartmentSearch'
  import UserSearch from '@/components/common/inputs/UserSearch'
  import LotNumberSearch from '@/components/common/inputs/LotNumberSearch'

  import Dropdown from '@/widgets/dropdown-new'

  export default {
    components: {
      CategoriesSearch,
      DepartmentSearch,
      UserSearch,
      LotNumberSearch,
      Dropdown
    },

    data: () => ({
      filters: {
        reportType: ReportType.PROCEDURES_BY_STAGE,
        creationDate: {
          from: undefined,
          to: undefined,
        },
        publicationDate: {
          from: undefined,
          to: undefined,
        },
        price: {
          from : undefined,
          to: undefined,
          currency: undefined
        },
        organizer: {
          persons: undefined,
          departments: undefined
        },
        initiator: {
          departments: undefined
        },
        tender: {
          method: undefined,
          participationMode: undefined
        },
        categories: undefined,
        lotNumber: undefined,
        tenderNumber: undefined,
        countLot: undefined
      }
    }),

    methods: {
      onResetClick() {
        Object.assign(this.$data, this.$options.data.apply(this));
        this.$emit('clear');
      },

      async onShowReportClick() {
        this.$emit('showReport', this.filters);
      }
    }
  }
</script>

<style scoped>

</style>
